import React, { Component, Fragment } from 'react'
import Service from '../service/Service';
const service = new Service();
// import Cookies from 'js-cookie';
import ReligionPopup from './ReligionPopup';
import OriginPopup from './OriginPopup';
import RashiPopup from './RashiPopup';
import FilterCategory from './FilterCategory';
import { fetchInitialData5 } from "../fetchData";

class BabynameLandingAmp extends Component {
    constructor(props) {
        super(props)
        let initialData = [];
        let filterData = [];
        let window_width = '';
        let popularData = [];
        let originData = {};
        let religionData = [];
        let articleData = [];
        this.alphabetsAry = [];


        for (let i = 0; i < 26; i++) {
            this.alphabetsAry.push((i + 10).toString(36));
        }

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            
            if (window.__initialData__['initialData']['data1'] && window.__initialData__['initialData']['data1']) {
                initialData = window.__initialData__['initialData']['data1']['filters'];
                
            }
            if (window.__initialData__['initialData']['data2'] && window.__initialData__['initialData']['data2']['filters']) {
                filterData = window.__initialData__['initialData']['data2']['filters'];
            }
            if (window.__initialData__['initialData']['data3']) {
                originData = window.__initialData__['initialData']['data3'];
            }
            if (window.__initialData__['initialData']['data4']) {
                articleData = window.__initialData__['initialData']['data4']['article'];
            }
            if (window.__initialData__['initialData']['data5']) {
                popularData = window.__initialData__['initialData']['data5']['Popularity'];
            }
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                if (props.staticContext.initialData['initialData']['data1'] && props.staticContext.initialData['initialData']['data1']) {
                    initialData = props.staticContext.initialData['initialData']['data1']['filters'];
                }
                if (props.staticContext.initialData['initialData']['data2'] && props.staticContext.initialData['initialData']['data2']['filters']) {
                    filterData = props.staticContext.initialData['initialData']['data2']['filters'];
                }
                if (props.staticContext.initialData['initialData']['data3']) {
                    originData = props.staticContext.initialData['initialData']['data3'];
                }
                if (props.staticContext.initialData['initialData']['data4']) {
                    articleData = props.staticContext.initialData['initialData']['data4']['article']
                }
                if(props.staticContext.initialData['initialData']['data5']){
                    popularData = props.staticContext.initialData['initialData']['data5']['Popularity']
                }
            }
        }
        this.state = {
            initialData: initialData,
            filterData: filterData,
            window_width : window_width,
            popularData : popularData,
            originData  : originData,
            articleData : articleData,
            genderapplied : 'false',
            originapplied : 'false',
            rashiapplied : 'false',
            religionapplied : 'false',
            allSelectedReligion : 'Religion',
            allSelectedOrigin : 'Origin',
            allSelectedRashi : 'Rashi',
            allSelectedGender : 'Gender',
            filterapplied : false,
            radioSelec: false
        };

        this.disPageNo = 1;
        if (this.props.match.params.page && this.props.match.params.page > 0) {
            this.disPageNo = parseInt(this.props.match.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
    }
    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 10;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }

        let obj1 = {
            url: global.api_url + "getfilterdataforlanding",
            body:JSON.stringify({
                "pagesize": size,
                "pageno": 1
            })
        };
        let obj2 = {
            url: global.api_url + "getfilterlist",
            body: JSON.stringify({
                
            })
        };

        let obj3 = {
            url : global.api_url + "getoriginreligionlist",
            body: JSON.stringify({
                "pagesize": size,
                "pageno": 1
            })
        }

        let obj4 = {
            url : global.api_url + "getarticlesdata",
            body: JSON.stringify({
                "pagesize": size,
                "pageno": 1
            })
        }
        let obj5 = {
            url : global.api_url + "getpopularbabynames",
            body: JSON.stringify({
                "pagesize": size,
                "pageno": 1
            })
        }
        return fetchInitialData5(obj1, obj2, obj3, obj4, obj5, JSON.stringify(header));
    }
    
    /*
     *  scroll to body top
     *  element, position and time duration
     */
    
    // componentDidMount() {
    //     if (navigator.onLine) {
    //         let size = 10;
    //         if (this.disPageNo > 1) {
    //             size = 10 * this.disPageNo;
    //         }

    //         if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
    //             service.showLoader();
    //             this.babynamelandingData(1, size);
    //         }

    //         if(this.state.filterData && this.state.filterData.length < 1){
    //             this.filterData();
    //         }
            
    //         if(this.state.originData.msg == undefined){
    //             this.originData();
    //         }
    //         if(this.state.articleData && this.state.articleData.length < 1){
    //             this.articleData();
    //         }
    //         if(this.state.popularData && this.state.popularData.length < 1){
    //             this.popularNameData();
    //         }
    //     } else {

    //         if (localStorage.getItem('babynameLanding')) {
    //             this.setState(
    //                 { initialData: JSON.parse(localStorage.getItem('babynameLanding')) },
    //                 () => { actions.loadSliders(); }
    //             );
    //         }
    //         if( localStorage.getItem('filterData')) {
    //             this.setState({ filterData: JSON.parse(localStorage.getItem('filterData')) },
    //             () => { actions.loadSliders();  }
    //             );
    //         }

    //         if(localStorage.getItem('originData')){
    //             this.setState({ originData: JSON.parse(localStorage.getItem('originData')) }, () => { actions.loadData();});
    //         }
    //         if(localStorage.getItem('religionData')){
    //             this.setState({ religionData : JSON.parse(localStorage.getItem('religionData')) }, () => { actions.loadData();});
    //         }

    //         if(localStorage.getItem('articleData')){
    //             this.setState({ articleData: JSON.parse(localStorage.getItem('articleData')) }, () => { service.loadImages(); actions.loadSliders();});
    //         }

    //         if(localStorage.getItem('popularData')){
    //             this.setState({ popularData : JSON.parse(localStorage.getItem('popularData')) }, () => { actions.loadSliders();});
    //         }

    //         service.showLoader();
    //         setTimeout(function(){
    //             service.hideLoader();
    //         }, 500)

    //     }
    //     window.scrollTo(0,0);
        
    //     this.setState({window_width : window.innerWidth})
    //     actions.loadSliders();
    //     actions.loadData();
        // localStorage.setItem('all_filters', false);

    //     localStorage.setItem('selectedvalgender', []);
    //     localStorage.setItem('selectedvalgod', []);
    //     localStorage.setItem('selectedvalnakshatra', []);
    //     localStorage.setItem('selectedvalnumerology', []);
    //     localStorage.setItem('selectedvalorigin', []);
    //     localStorage.setItem('selectedvalrashi', []);
    //     localStorage.setItem('selectedvalreligion', []);
    //     localStorage.setItem('selectedvalstarting', []);

        // Cookies.set('all_filters', false);
    //     Cookies.set('selectedvalgender', []);
    //     Cookies.set('selectedvalgod', []);
    //     Cookies.set('selectedvalnakshatra', []);
    //     Cookies.set('selectedvalnumerology', []);
    //     Cookies.set('selectedvalorigin', []);
    //     Cookies.set('selectedvalrashi', []);
    //     Cookies.set('selectedvalreligion', []);
    //     Cookies.set('selectedvalstarting', []);

    //     // Cookies.set("babynamemeaning", '');
    //     // localStorage.setItem('babynamemeaning', '');
    // }

    // componentWillUnmount() {
    //     document.removeEventListener("click", actions.domClick);
    // }

    // popularNameData() {
    //     var postData = {};
    //     var url = global.api_ci_url + "Babynames/getpopularbabynames";
    //     service.postServiceCall(url, postData).then((json) => {
    //         if(json['msg'] == 1){
    //             if(this.state.popularData && this.state.popularData.length < 0){
    //                 this.setState({popularData : json['Popularity']}, () => { actions.loadData();});
    //             } else{
    //                 localStorage.setItem('popularData', JSON.stringify(json['Popularity']));
    //                 this.setState({popularData : json['Popularity']}, () => { actions.loadData();});
    //             }
    //         }
    //     }).catch((error) => {
    //         console.error(error);
    //     });
    // }
    // originData() {
    //     var postData = {};
    //     var url = global.api_ci_url + "Babynames/getoriginreligionlist";

    //     service.postServiceCall(url, postData).then((json) => {
    //         if (json['msg'] == "1") {
    //             if (this.state.originData.msg == undefined) {
    //                 this.setState({ originData: json }, () => { actions.loadData();});
    //             } else {
    //                 localStorage.setItem('originData', JSON.stringify(json));
    //                 this.setState({ originData: json }, () => { actions.loadData();});
    //             }
    //         }
    //     }).catch((error) => {
    //         console.error(error);
    //     });
    // }
    // articleData() {
    //     var postData = {};
    //     var url = global.api_ci_url + "Babynames/getarticlesdata";
    //     service.postServiceCall(url, postData).then((json) => {
    //         if (json['msg'] == "1") {
    //             if (this.state.articleData && this.state.articleData.length > 0) {
    //                 this.setState({ articleData: json['article'] }, () => { service.loadImages(); actions.loadSliders();})
    //             } else {
    //                 localStorage.setItem('articleData', JSON.stringify(json['article']))
    //                 ;
    //                 this.setState({ articleData: json['article'] }, () => { service.loadImages(); actions.loadSliders();});
    //             }
    //         }
    //     }).catch((error) => {
    //         console.error(error);
    //     });
    // }
    // babynamelandingData(pageno, size) {
    //     var postData = {
    //         "pagesize": size,
    //         "pageno": pageno
    //     }
    //     var url = global.api_ci_url + "Babynames/getfilterdataforlanding";

    //     service.postServiceCall(url, postData).then((json) => {

    //         if (json['msg'] == 1) {

    //             if (this.state.initialData && this.state.initialData.length > 0) {
    //                 if (size == (pageno * 10)) {
    //                     this.setState({ initialData: json['filters'] }, () => { service.loadImages(); actions.loadSliders(); });
    //                 } else {
    //                     let ary = this.state.initialData;
    //                     this.setState({ initialData: ary.concat(json['filters']) }, () => { service.loadImages(); actions.loadSliders(); });
    //                 }
    //                 // if (parseInt(pageno) !== 1) {
    //                 //     this.appendURL();
    //                 // }
                    
    //             } else {
    //                 localStorage.setItem('babynameLanding', JSON.stringify(json['filters']));
    //                 this.setState({ initialData: json['filters'] }, () => { service.loadImages(); actions.loadSliders(); });
    //             }
    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    // filterData() {
    //     var postData = {};
    //     var url = global.api_ci_url + "Babynames/getfilterlist";
    //     service.postServiceCall(url, postData).then((json) => {
    //         if (json['filters']) {
    //             if (this.state.filterData && this.state.filterData.length > 0) {
    //                 this.setState({ filterData: json['filters'] })
    //             } else {
    //                 localStorage.setItem('filterData', JSON.stringify(json['filters']));                   
    //                 this.setState({ filterData: json['filters'] });
    //             }
    //         }
    //     }).catch((error) => {
    //         console.error(error);
    //     });
    // }
    // startwithList(event){
    //     // event.stopPropagation();
    //     service.showLoader();
    //     [].forEach.call(document.querySelector(".alphabets").querySelectorAll("li"), function(ele){
    //         ele.className = ele.className.replace(/\active\b/, "")
    //     })
    //     event.target.classList += " active";
    //     var selected_alphabet = (event.target.innerHTML).toLowerCase();
        
    //     _selectedvalstarting = [];
    //     _selectedvalstarting.push(selected_alphabet);

    //     localStorage.setItem("selectedvalstarting", _selectedvalstarting);
    //     Cookies.set("selectedvalstarting", _selectedvalstarting);
        
    //     var _selectedvalgender= [];
    //     [].forEach.call(document.querySelectorAll(".gender_tabs .active"), function(ele){
    //         _selectedvalgender.push(ele.getElementsByTagName("span")[0].innerHTML.toLowerCase());
    //     })
        
    //     if(_selectedvalgender.length != 0){
    //         localStorage.setItem('selectedvalgender', _selectedvalgender);
    //         Cookies.set("selectedvalgender", _selectedvalgender);
    //     }
    //     var gender_array = localStorage.getItem('selectedvalgender').split(",");
       
    //     if(_selectedvalgender.length != 0){
    //         if(gender_array.length == 1){
    //            this.props.history.push(service.getRedirectUrl("/baby-names/" + gender_array[0] + "/starting-with/" + selected_alphabet + "/"));
    //         } else {
    //             this.props.history.push(service.getRedirectUrl("/baby-names/search/"));
    //         }
    //     } else {
    //         this.props.history.push(service.getRedirectUrl("/baby-names/starting-with/" + selected_alphabet + "/"));
    //     }
    // }
    
    // gender_selection(event, gender){
    //     if(document.querySelector("." + gender + "_tab").classList.contains("active")){
    //         var ele = document.querySelector("." + gender + "_tab");
    //         ele.className = ele.className.replace(/\ active\b/, "");
            
    //         var index = _selectedvalgender.indexOf(gender);
    //         if (index > -1) {
    //             _selectedvalgender.splice(index, 1);
    //         }
    //     } else {
    //         document.querySelector("." + gender + "_tab").classList += " active";
    //         if(_selectedvalgender.indexOf(gender) == -1){
    //             _selectedvalgender.push(gender);
    //         }
    //     }

    //     document.querySelector(".nm-add span").innerHTML = 'Select alphabet';
    //     document.querySelector(".name-added").classList += " add_show";
            
    //     setTimeout(() => {
    //         document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
    //     }, 1000);

    // }

    // toPopularNames(event, popular_gender){
    //     _selectedvalgender = [];

    //     var only_gender = popular_gender.split(" ")[2].toLowerCase();
        
    //     localStorage.setItem("selectedvalgender", []);
    //     Cookies.set("selectedvalgender", []);

    //     _selectedvalgender.push(only_gender);
       
    //     localStorage.setItem("selectedvalgender", _selectedvalgender);
    //     Cookies.set("selectedvalgender", _selectedvalgender);

    //     this.props.history.push(service.getRedirectUrl("/baby-names/" + only_gender + "/amp/"));
    // }
    // handleChange(genderForm){
    //     console.log(genderForm);
    // }
    
    render() {
        if(this.state.originData.msg !== undefined){
            var jsonOrigin = this.state.originData.BrowseByOrigin;
            var jsonReligion = this.state.originData.NameByReligon;
            
        } else {
            var jsonOrigin = [];
            var jsonReligion = [];
        }
        let jsonPopular = this.state.popularData;
        let jsonArticle = this.state.articleData; 
        let alphabets_array = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U"];
        let alphabets_array_center = ["V","W","X","Y","Z"];
        // console.log(this.state.radioSelec);

        return (
            <main className="baby-names-main main-container">
                
                <meta name="atdlayout" content="babynames" />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/amp/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby Names</span>
                    </div>
                    <h1 className="B24_00">Baby Names & Meanings</h1>
                    <div className="">
                        <span className="R15_9e baby_name_finder_text">Choosing the perfect name for your baby may seem like a tough decision, especially with so many options floating around. Choose from our collection of baby boy names and baby girl names which let’s you get as specific as you want, so you choose a unique, yet meaningful name for your little one!</span>
                    </div>
                   
                </div>
                <div className="sub-container left">
                    <div className="baby_names_container left">
                        <div className="data-container left landing">
                           
                                {/* search baby name / meaning starts */}
                                <div className="seach_name_block">
                                    <div className="search_name desktop_view_searchname">
                                        <div className="search_container" style={{overflow : 'visible'}}>
                                            <div className="popular_names_heading">
                                                <h2 className="M18_42">
                                                    Search Baby Names
                                                </h2>
                                            </div>
                                            <div className="discussion-readless">
                                                <span className="R15_9e baby_name_finder_text">Have a special name in mind or looking for some inspiration? Type your keyword ( it could be a meaning you love, a religion etc.) and we’ll give you meanings and variations to help make up your mind!</span>
                                            </div>
                                           
                                            <span className="search_input">
                                                <a href={service.getRedirectUrl('/baby-names/finder/amp/')}>
                                                    <input type="search" placeholder="Enter your keyword here..." />
                                                    <span className="icon search_icon right" data-icon-font="'"></span>
                                                </a>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mobile_view_searchname">
                                        <amp-img layout="responsive" width="320" height="170" src="https://cdn.cdnparenting.com/articles/babynameimages/landing_image.webp"></amp-img>
                                        <a className="search_input" href={service.getRedirectUrl("/baby-names/finder/amp/")}>
                                            <input type="search" placeholder="Search by Baby Names & Meaning" />
                                            <span className="icon search_icon right" data-icon-font="'"></span>
                                        </a>
                                    </div>
                                   
                                    {this.state.filterData && 
                                        <FilterCategory eleRef={this.state.filterData} eleThis={this} />
                                    }
                                    {/* <!--search baby name / meaning ends--> */}
                                    {/* <!--seach by filter starts--> */}
                                    <div className="search_name search_by_filter mobile_view_searchbyfilter">
                                        <div className="search_container">
                                            <div className="popular_names_heading"><h2 className="M18_42">Baby Names Generator</h2></div>
                                            <div className="discussion-readless">
                                                <span className="R15_9e baby_name_finder_text">On the hunt for boy names or girl names based on gender, religion, numerology or more? Our baby names finder allows you to search for a particular set of names, whether its a particular baby boy names starting alphabet or a baby name search by letters, religion, etc. It’s never been easier to find the right baby name for your munchkin!</span>    
                                            </div>
                                            <form className="sample-form" method="post" id="findNames" name="findNames" action-xhr={`${global.hosturl}parenting/BabynamesAmp/findNames`} encType="application/json">

                                                <div className="gender_popup_overlay overlay" id="gender_popup_overlay" hidden>
                                                    <div className="gender_popup filter_popups">
                                                        <span className="M18_42">Please Select Gender</span>
                                                            <ul>
                                                                <amp-selector multiple="" name="gender-selector[]" id="mygender"
                                                                    layout="container"
                                                                    //className="radio-selector"
                                                                    on="select: AMP.setState({
                                                                        allSelectedGender: event.selectedOptions,
                                                                        allSelectedReligion : religionapplied != 'true' ? 'Religion' : (allSelectedReligion != '' ? allSelectedReligion : 'Religion'),
                                                                        allSelectedOrigin : originapplied != 'true' ? 'Origin' : (allSelectedOrigin != '' ? allSelectedOrigin : 'Origin'),
                                                                        allSelectedRashi : rashiapplied != 'true' ? 'Rashi' : (allSelectedRashi != '' ? allSelectedRashi : 'Rashi')
                                                                        })">
                                                                    <div option="Boy"><span className="checkbox1" data-icon-font="z"></span><span className="checkbox2" data-icon-font="A"></span>Boy</div>
                                                                    <div option="Girl"><span className="checkbox1" data-icon-font="z"></span><span className="checkbox2" data-icon-font="A"></span>Girl</div>
                                                                    <div option="Unisex"><span className="checkbox1" data-icon-font="z"></span><span className="checkbox2" data-icon-font="A"></span>Unisex</div>
                                                                </amp-selector>
                                                            </ul>
                                                            <div className="action_buttons right">
                                                                <span tabIndex="0" role="button" className="M14_9e cancelfilterbtn" on="tap:gender_popup_overlay.hide,applygender1.clear, AMP.setState({'allSelectedGender': genderapplied != 'true' ? 'Gender' : (allSelectedGender != '' ? allSelectedGender : 'Gender'),
                                                                
                                                                'allSelectedReligion' : religionapplied != 'true' ? 'Religion' : (allSelectedReligion != '' ? allSelectedReligion : 'Religion'),
                                                                'allSelectedOrigin' : originapplied != 'true' ? 'Origin' : (allSelectedOrigin != '' ? allSelectedOrigin : 'Origin'),
                                                                'allSelectedRashi' : rashiapplied != 'true' ? 'Rashi' : (allSelectedRashi != '' ? allSelectedRashi : 'Rashi')

                                                                })">CANCEL</span>
                                                                
                                                                <span tabIndex="0" role="button" className="applyfilterbtn M14_pink" on="tap:gender_popup_overlay.hide, AMP.setState({'genderapplied' : 'true'})">APPLY</span>
                                                            </div>
                                                    </div>
                                                </div>
                                                {this.state.initialData && this.state.initialData[1] && 
                                                    <ReligionPopup eleRef={this.state.initialData[1].values} />
                                                }
                                                {this.state.initialData && this.state.filterData[2] && 
                                                    <OriginPopup eleRef={this.state.filterData[2].values} />
                                                }
                                                {this.state.initialData && this.state.initialData[3] && 
                                                    <RashiPopup eleRef={this.state.initialData[3].values} />
                                                }
                                                <html dangerouslySetInnerHTML={{ __html:`
                                                <div>
                                                    <ul class="left">
                                                        <li class="left gender_filter" tabIndex="0" role="button" on="tap:gender_popup_overlay.show">
                                                            <div class="searchfilter left">
                                                            <span class="R14_42 left selected_filter" [text]="allSelectedGender != '' ? allSelectedGender : 'Gender'">Gender</span>
                                                            <span class="icon arrow_icon right" data-icon-font="j"></span>
                                                            </div>
                                                        </li>
                                                        <li class="left religion_filter" tabIndex="0" role="button" on="tap:religion_popup_overlay.show">
                                                            <div class="searchfilter left">
                                                                <span class="R14_42 left selected_filter" [text]="allSelectedReligion != '' ? allSelectedReligion : 'Religion'">Religion</span>
                                                                <span class="icon arrow_icon right" data-icon-font="j"></span>
                                                            </div>                                        
                                                        </li>
                                                        <li class="left origin_filter" tabIndex="0" role="button" on="tap:origin_popup_overlay.show">
                                                            <div class="searchfilter">
                                                                <span class="R14_42 left selected_filter" [text]="allSelectedOrigin != '' ? allSelectedOrigin : 'Origin'">Origin</span>
                                                                <span class="icon arrow_icon right" data-icon-font="j"></span>
                                                            </div>
                                                        </li>
                                                        <li class="left rashi_filter" tabIndex="0" role="button" on="tap:rashi_popup_overlay.show">
                                                            <div class="searchfilter">
                                                                <span class="R14_42 left selected_filter" [text]="allSelectedRashi != '' ? allSelectedRashi : 'Rashi'">Rashi</span>
                                                                <span class="icon arrow_icon right" data-icon-font="j"></span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                   
                                                    </div>
                                                    `}}>
                                                </html>
                                                <div className="filter_buttons">
                                                    <div className="morefilters_cont" id="dev_find_nm" data-vars-event-category="Baby Names - Search by Baby Names using Filters" data-vars-event-action="Find Names" data-vars-event-label="FILTER VALUE">
                                                        <input type="submit" value="FIND NAMES" className="find_names askB_1"/>
                                                    </div>
                                                    <div className="morefilters_cont">
                                                        {
                                                                <span className="M15_61 morefilter_link" tabIndex="0" role="button" on="tap:filter_popup_overlay.show,subgender.hide,subreligion.hide,suborigin.hide,subnumerology.hide,subrashi.hide,subnakshatra.hide,substartwith.hide,subgod.hide, subgender.show">
                                                                <span data-icon-font="K" className="R15_9e filterIcon icon"></span>
                                                                More Filter
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                {/*seach by filter ends */ }
                                {/*find baby name starting with starts */ }
                                </div>
                                <div className="alphabet_block">
                                    <div className="search_name search_name_starts_with">
                                        <div className="search_container">
                                            <div className="M18_42 startingalpha">Baby Names Starting With Alphabet
                                            </div>
                                            <form className="sample-form" method="post" name="applygender1" action-xhr={`${global.hosturl}parenting/BabynamesAmp/applyGenderAlpha`} encType="application/json">
                                                <div className="gender_tabs left">
                                                    <ul className="left">
                                                        <amp-selector multiple="" name="allgender-selector[]" id="mygenderwithalphabet"
                                                            layout="container" //className="allgender-selector"
                                                            >
                                                            <li option="girl" className="left girl_tab" tabIndex="0" role="button" on="tap:snackbarSlideIn.restart">
                                                                <div className="gender_box">
                                                                    <div className="gender_image_cont">
                                                                        <amp-img layout="responsive" width="54" height="54" src="https://cdn.cdnparenting.com/articles/babynameimages/desk_babygirl.svg" alt="" title="" ></amp-img>
                                                                    </div>
                                                                    <span className="R14_75">GIRL</span>
                                                                </div>
                                                            </li>
                                                            <li option="boy" className="left boy_tab" tabIndex="0" role="button" on="tap:snackbarSlideIn.restart">
                                                                <div className="gender_box">
                                                                    <div className="gender_image_cont">
                                                                    <amp-img layout="responsive" width="54" height="54" src="https://cdn.cdnparenting.com/articles/babynameimages/desk_babyboy.svg" alt="" title=""></amp-img>
                                                                    </div>
                                                                    <span className="R14_75">BOY</span>
                                                                </div>
                                                            </li>
                                                            <li option="unisex" className="left unisex_tab" tabIndex="0" role="button" on="tap:snackbarSlideIn.restart">
                                                                <div className="gender_box">
                                                                    <div className="gender_image_cont">
                                                                    <amp-img layout="responsive" width="54" height="54" src="https://cdn.cdnparenting.com/articles/babynameimages/unisex.svg" alt="" title="" layout="responsive"></amp-img>
                                                                    </div>
                                                                    <span className="R14_75">UNISEX</span>
                                                                </div>
                                                            </li>
                                                        </amp-selector>

                                                        <div className="snackbar_amp">
                                                            Please Select alphabet
                                                        </div>
                                                    </ul>
                                                </div>
                                                
                                                <div className="alphabet_list">
                                                    <ul className="radio-toolbar">
                                                        {
                                                            alphabets_array.map((value, index) =>
                                                            (value == "G" || value == "N" || value == "U") ?
                                                                <li key={index} className="left alphabets no_marg">
                                                                    <input type="radio" value={value.toLowerCase()} name="selected_alpha" id={`alpha_${value}`} required/>
                                                                    <label className="M16_white" htmlFor={`alpha_${value}`}>
                                                                        {value}
                                                                    </label>
                                                                </li>
                                                            :
                                                                (value == "M") ?
                                                                <li key={index} className="left alphabets no_marg_desk">
                                                                    <input type="radio" value={value.toLowerCase()} name="selected_alpha"id={`alpha_${value}`} required/>
                                                                    <label className="M16_white" htmlFor={`alpha_${value}`}>
                                                                        {value}
                                                                    </label>
                                                                </li>
                                                            :
                                                                <li key={index} className="left alphabets">
                                                                    <input type="radio" value={value.toLowerCase()} name="selected_alpha"id={`alpha_${value}`} required/>
                                                                    <label className="M16_white" htmlFor={`alpha_${value}`}>
                                                                        {value}
                                                                    </label>
                                                                </li>
                                                            )
                                                        }
                                                        <div className="alpha_center" key={Math.random}>
                                                            {   alphabets_array_center.map((value1, key) =>
                                                                    (value1 != "Z") ?
                                                                    <li key={key} className="left alphabets">
                                                                        <input type="radio" value={value1.toLowerCase()} name="selected_alpha" id={`alpha_${value1}`} required/>
                                                                        <label className="M16_white" htmlFor={`alpha_${value1}`}>
                                                                           {value1}
                                                                        </label>
                                                                    </li>
                                                                    :
                                                                    <li key={key} className="left alphabets no_marg no_marg_desk">
                                                                        <input type="radio" value={value1.toLowerCase()} name="selected_alpha" id={`alpha_${value1}`} required/>
                                                                        <label className="M16_white" htmlFor={`alpha_${value1}`}>
                                                                            {value1}                       
                                                                        </label>
                                                                    </li>
                                                                )
                                                            }
                                                        </div>
                                                    </ul>
                                                </div>

                                                <button type="submit" id="allgendersAlpha" className="askB_1" data-vars-event-category="Baby Names - Search by Alphabet" data-vars-event-action="LETTER VALUE" >Apply Filter</button>
                                            </form>
                                            
                                           
                                        </div>
                                    </div>
                                </div>
                                
                                { /*<!--find baby name starting with ends--> */}
                                <div className="name-added">
                                    <div className="nm-add">
                                        <span>
                                        </span>
                                    </div>
                                </div>
                                { /*<!--popular girls name--> */}
                                
                                {jsonPopular && jsonPopular.map((item, index) => (
                                <div className="popularnames_block" data-key={index} key={index}>
                                    <div className="search_name">
                                        <div className="popular_names_heading">
                                            <div className="R12_9e modified_text">{`Modified On : 
                                              ${item.modifiedDate.split("T")[0].split("-")[2] + "/" + item.modifiedDate.split("T")[0].split("-")[1] + "/" + item.modifiedDate.split("T")[0].split("-")[0]}`}
                                            </div>
                                            <h2 className="M18_42">
                                                {
                                                    (index == 0) ?
                                                    "Most Popular Baby Girl Names of 2020" :
                                                    "Most Popular Baby boy Names of 2020"
                                                }
                                            </h2>
                                            {/* <span className="R15_42 dynamic_number">
                                                {item.subTitle}
                                            </span> */}
                                        </div>
                                        <div className="popular_name_desc">
                                            <div className="discussion-readless">
                                                <span className="R15_9e baby_name_finder_text">
                                                    {
                                                        (index == 0) ? 
                                                        "Browse from the top baby girl names of 2020 and keep up with the changing trends! When choosing names for a girl, it’s essential to pick a unique, yet meaningful and cute baby girl name that fits your baby perfectly! Here’s a list of the most popular baby girl names, along with their meanings." :

                                                        "Want to keep up with the latest trends in names for a boy? We’ve got you covered! Choose a name that was made to fit your baby boy perfectly, with this list of top baby boy names of 2020, along with their meanings. Choosing unique boy names has never been easier. Shortlist your favourites, take votes, and pick away! "
                                                    }    
                                                </span>
                                            </div>
                                        </div>
                                        <div className="popular_name_list">
                                            <ul className="left">
                                                {item.names.slice(0, 20).map((names, key) => 
                                                    (<li className="left" key={key}>
                                                        <div className="name_cont">
                                                            <a href={service.getRedirectUrl(`/baby-names/meaning-of-${names.babyName.replace(/ /g, "-").replace(/#/g, "-").replace("?", "-").replace(/--/g, "-").toLowerCase()}/amp/`)} title={names.babyName}>
                                                                {
                                                                    (index == 1) ? 
                                                                    (<span className="icon boy_icon" data-icon-font="&#xe022;"></span>) :
                                                                    (<span className="icon girl_icon" data-icon-font="&#xe01f;"></span>)
                                                                }  
                                                                {
                                                                    (index == 1) ? 
                                                                <span className="R15_61" id="dev_boys">{names.babyName}</span> :
                                                                <span className="R15_61" id="dev_girls">{names.babyName}</span>

                                                                }                                                            
                                                            </a>
                                                        </div>
                                                    </li>)
                                                )}
                                            </ul>
                                        </div>
                                        <div className="view_all_names">
                                        { (index == 0)?
                                              <div className="dev_all_girls" >
                                            <a href={service.getRedirectUrl("/baby-names/girl/amp/")}><span className="M15_white">View All</span></a></div> :
                                              <div className="dev_all_boys" >
                                            <a href={service.getRedirectUrl("/baby-names/boy/amp/")}><span className="M15_white">View All</span></a></div>
                                             }                                         </div>
                                    </div>
                                </div>
                                ))}

                               {/* <!--browse by origin --> */}
                               {
                               (jsonOrigin && jsonOrigin.length > 0) ?
                               (jsonOrigin.map((result, index) => (
                                    <div className="originnames_block" key={index}>
                                        <div className="search_name">
                                            <div className="browse_by_origin_heading">
                                                <h2 className="M18_42">Baby Names by Origin</h2>
                                            </div>
                                            <div className="origin_names_cont">
                                                <div className="origin_name_desc">
                                                    <div className="discussion-readless">
                                                        <span className="R15_9e mobile_babyname_finder baby_name_finder_text">Choosing a baby name based on origin gives you insight into various cultures around the world! You’ll be surprised at how many unique or uncommon baby names originate from the culture of your choice, as well as the beautiful meanings behind them! Pick the culture you’d like to base your baby’s name on, and we’ll give you a list of names with meanings.</span>
                                                        <span className="R14_9e desktop_babyname_finder baby_name_finder_text">Choosing a baby name based on origin gives you insight into various cultures around the world! You’ll be surprised at how many unique or uncommon baby names originate from the culture of your choice, as well as the beautiful meanings behind them! Pick the culture you’d like to base your baby’s name on, and we’ll give you a list of names with meanings.</span>                       
                                                    </div>
                                                </div>
    
                                                <div className="browse_name_list" id="dev_nm_origin">
                                                    <ul className="left">
                                                        {result.originList.slice(0, 5).map((value, index) => 
                                                        (
                                                            <li key={index} className="left">
                                                                <a href={service.getRedirectUrl(`/baby-names/origin/${
                                                                    (value.key.split(" ")[1]) ?
                                                                    (`${value.key.split(" ")[0]}-${value.key.split(" ")[1]}`.toLowerCase()) :

                                                                    (value.key.split(" ")[0].toLowerCase())
                                                                    }/amp/`)} className="R15_42">
                                                                    {`${value.key} Baby Names`}
                                                                    <span data-icon-font="l" className="icon right R14_75"></span>
                                                                </a>
                                                            </li>
                                                        )
                                                        )}
                                                    </ul>
                                                </div>
                                                <div className="view_all_names" id="dev_all_origin">
                                                    <a href={service.getRedirectUrl("/baby-names/origin/amp/")}>
                                                        <span className="M15_white">View All</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))) :
                                ''
                                }
                                
                                {
                                (jsonReligion && jsonReligion.length > 0) ?
                                (jsonReligion.map((result, index) => (
                                    <div className="originnames_block names_by_religion_block" key={index}>
                                    <div className="search_name">
                                        <div className="browse_by_origin_heading">
                                            <h2 className="M18_42">Baby Names by Religion</h2>
                                        </div>
                                        <div className="origin_names_cont">
                                            <div className="religion_name_desc">
                                                <div className="discussion-readless">
                                                        <span className="R15_9e mobile_babyname_finder baby_name_finder_text">Religion plays a huge part when choosing a name for your baby. All you have to do is pick your religion, and we’ll give you a list of unique, meaningful names. Choose from traditional or modern religious baby names, and you’ll have picked the perfect name for your little one!</span>
                                                        
                                                        <span className="R14_9e desktop_babyname_finder baby_name_finder_text">Religion plays a huge part when choosing a name for your baby. All you have to do is pick your religion, and we’ll give you a list of unique, meaningful names. Choose from traditional or modern religious baby names, and you’ll have picked the perfect name for your little one!</span>
                                                </div>
                                               
                                            </div>

                                            <div className="browse_name_list" id="dev_nm_religion">
                                                <ul className="left">
                                                {result.religonList.slice(0, 5).map((value, index) => 
                                                (
                                                    <li key={index} className="left">
                                                        <a href={service.getRedirectUrl(`/baby-names/religion/${value.key.split(" ")[0].toLowerCase()}/amp/`)} className="R15_42">
                                                            {`${value.key} Baby Names`}
                                                            <span data-icon-font="l" className="icon right R14_75"></span>
                                                        </a>
                                                    </li>
                                                )
                                                )}
                                                </ul>
                                            </div>
                                            <div className="view_all_names" id="dev_all_religion">
                                                <a href={service.getRedirectUrl(`/baby-names/religion/amp/`)}>
                                                    <span className="M15_white">View All</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>    
                                </div>
                                ))) :
                                ''
                                }

                                { /*<!--articles--> */}
                                <div className="article_block search_name">
                                    <div className="articles_heading">
                                        <h2 className="M18_42">How to Choose Baby Name?</h2>
                                    </div>
                                    <div className="article_text">
                                        <span className="R15_75 baby_name_finder_text">
                                            Wondering what to keep in mind when choosing the perfect name for your baby? We’ll tell you! Here are some tips and tricks on choosing a meaningful name for your little one, that was made for him/her!
                                        </span>
                                    </div>

                                    <div className="articles_heading">
                                        <h2 className="M18_42">Articles on Baby Names</h2>
                                    </div>
                                    
                                    <div className="article_slider_cont" id="article_slider_cont">
                                        <amp-carousel height="145" layout="fixed-height" type="carousel">
                                            {jsonArticle && jsonArticle.map((value, index) => 
                                                <div key={index} className="experts-cnt" id="dev_art_view">
                                                    <a href={`${value.articleURL}?ref2=bncarouselslider/amp/`} target="_blank">
                                                        <div className="expert-image">
                                                            <amp-img layout="responsive" width="197" height="98" src={value.articleImage}></amp-img>
                                                        </div>
                                                        <div className="M14_42">{value.articleTitle}</div>
                                                    </a>
                                                </div>
                                            )}
                                        </amp-carousel>
                                    </div>
                                </div>

                                {/* <!--about baby names starts-->*/}
                                
                                {/*<!--about baby names ends-->*/}
                                {/*<!--popup starts-->*/}
                                
                                { /* <!--popup starts-->*/}
                                <div id="toastMsg" hidden>
                                    <span className="R14_white">Please select alphabet</span>
                                </div>
                                {/*<!--popup ends-->
                                <!--collection icon starts-->*/}

                                <div className="collectionListCont">
                                {   (global.ftk)?
                                    <a href={service.getRedirectUrl("/baby-names/favorite-baby-names/amp/")}>
                                        <span className="icon collectionIcon" data-icon-font="&#xe044;"></span>
                                    </a>
                                    :
                                    <div tabIndex="0" role="button" on="tap:loginToggle.restart">
                                        <a href={`${global.loginUrl}?URL=${global.currentURL}`} tabIndex="0" role="button">
                                            <span className="icon collectionIcon" data-icon-font="&#xe044;"></span>
                                        </a>
                                        <div className="alertMsgoverlay">
                                            <span className="alertmsg">Please Login</span>
                                        </div>
                                    </div>
                                }
                                </div>
                                {/*<!--collection icon ends-->*/}
                        
                    </div>
                </div>
                {/*<Right url={this.props.match.url} /> */ }
            </main>
        )
    }
}

export default BabynameLandingAmp



// WEBPACK FOOTER //
// src/shared/baby-names-amp/BabynamesAmp.js